<app-spinner-service></app-spinner-service>
<form [formGroup]="criarContaContabil" (ngSubmit)="onSubmit()" class="w-auto pt-4 pl-6 pr-6 pb-6">

    <div class="grid p-fluid col-12">
        <div class="col-6">
            <label for="descricao">Descrição</label>
            <input id="descricao" pInputText formControlName="descricao" class="w-full mt-1" />
        </div>

        <div class="col-6">
            <label for="saldo">Saldo</label>
            <p-inputNumber class="w-full mt-1" inputId="saldo" formControlName="saldo" mode="currency" currency="BRL"
                locale="pt-BR" />
        </div>

    </div>
    <div class="grid p-fluid col-12">
        <div class="col-6">
            <label for="tipo">Tipo de Conta</label>
            <p-dropdown id="tipoTransacaoSaldoAnteriorCadastro" formControlName="tipoTransacaoSaldoAnteriorCadastro" 
                [options]="tiposTransacao" optionLabel="label" optionValue="value" class="w-full mt-1 col-6">
            </p-dropdown>
        </div>
    </div>

        <div class="col-12 flex justify-content-between">
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger"
                    (click)="onCancel()"></p-button>
            </div>
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="submit" label="Salvar" icon="pi pi-check"
                    [disabled]="criarContaContabil.invalid"></p-button>
            </div>
        </div>

</form>